import { useMemo } from 'react'
import type { FolderResponse } from '../api/types'
import { buildTree, type TreeNode } from '../lib/tree'

export function FolderTree({
  folders,
  selected,
  onSelect,
  rootLabel = 'Room root',
}: {
  folders: FolderResponse[]
  selected: string | null
  onSelect: (folderId: string | null) => void
  rootLabel?: string
}) {
  const tree = useMemo(() => buildTree(folders), [folders])

  return (
    <nav className="tree" aria-label="Folders">
      <button
        type="button"
        className={selected === null ? 'tree-item tree-item-selected' : 'tree-item'}
        onClick={() => onSelect(null)}
      >
        <span className="tree-index">—</span>
        <span className="tree-name">{rootLabel}</span>
      </button>
      {tree.length === 0 && <p className="muted small tree-empty">No folders yet.</p>}
      <TreeLevel nodes={tree} selected={selected} onSelect={onSelect} />
    </nav>
  )
}

function TreeLevel({
  nodes,
  selected,
  onSelect,
}: {
  nodes: TreeNode[]
  selected: string | null
  onSelect: (folderId: string | null) => void
}) {
  return (
    <ul className="tree-level">
      {nodes.map((node) => (
        <li key={node.folder.id}>
          <button
            type="button"
            className={selected === node.folder.id ? 'tree-item tree-item-selected' : 'tree-item'}
            onClick={() => onSelect(node.folder.id)}
            title={`${node.folder.indexNumber} ${node.folder.name}`}
          >
            <span className="tree-index mono">{node.folder.indexNumber}</span>
            <span className="tree-name">{node.folder.name}</span>
            {node.folder.documentCount > 0 && (
              <span className="tree-count">{node.folder.documentCount}</span>
            )}
          </button>
          {node.children.length > 0 && (
            <TreeLevel nodes={node.children} selected={selected} onSelect={onSelect} />
          )}
        </li>
      ))}
    </ul>
  )
}
